import { render, staticRenderFns } from "./ArchivedProjectsList.vue?vue&type=template&id=0e13d9e0&"
import script from "./ArchivedProjectsList.vue?vue&type=script&lang=js&"
export * from "./ArchivedProjectsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports